import { render, staticRenderFns } from "./participant-status.vue?vue&type=template&id=fed2bcfa&"
import script from "./participant-status.vue?vue&type=script&lang=js&"
export * from "./participant-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "participant-status.vue"
export default component.exports